import { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export function ImageTextCarousel({ slides = [], autoPlayInterval = 5000 }) {
  const [current, setCurrent] = useState(0);

  const slide = slides[current];

  useEffect(() => {
    if (!slides.length) return;

    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, autoPlayInterval);

    return () => clearInterval(timer);
  }, [slides.length, autoPlayInterval]);

  if (!slide) return null;

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    // <section
    //   style={{
    //     position: 'relative',
    //     width: '100%',
    //     minHeight: '620px',
    //     overflow: 'hidden',
    //     background: '#020617',
    //   }}
    // >
    //   <img
    //     key={slide.image}
    //     src={slide.image}
    //     alt={slide.title}
    //     style={{
    //       position: 'absolute',
    //       inset: 0,
    //       width: '100%',
    //       height: '100%',
    //       objectFit: 'cover',
    //       zIndex: 0,
    //     }}
    //   />

    //   <div
    //     style={{
    //       position: 'absolute',
    //       inset: 0,
    //       zIndex: 1,
    //       background:
    //         'linear-gradient(90deg, rgba(2,6,23,.96) 0%, rgba(2,6,23,.78) 45%, rgba(2,6,23,.25) 100%)',
    //     }}
    //   />

    //   <div
    //     style={{
    //       position: 'relative',
    //       zIndex: 2,
    //       minHeight: '620px',
    //       display: 'flex',
    //       alignItems: 'center',
    //       padding: '0 7%',
    //     }}
    //   >
    //     <div
    //       style={{
    //         maxWidth: '660px',
    //         padding: '2.5rem',
    //         borderRadius: '32px',
    //         background: 'rgba(15,23,42,.58)',
    //         border: '1px solid rgba(255,255,255,.12)',
    //         boxShadow: '0 30px 90px rgba(0,0,0,.45)',
    //         backdropFilter: 'blur(18px)',
    //       }}
    //     >
    //       <div
    //         style={{
    //           display: 'inline-flex',
    //           marginBottom: '1.5rem',
    //           padding: '.55rem .9rem',
    //           borderRadius: '999px',
    //           background: 'rgba(14,165,233,.12)',
    //           border: '1px solid rgba(56,189,248,.28)',
    //           color: '#7dd3fc',
    //           fontSize: '.78rem',
    //           fontWeight: 800,
    //           letterSpacing: '2px',
    //           textTransform: 'uppercase',
    //         }}
    //       >
    //         Soluções Digitais
    //       </div>

    //       <h2
    //         style={{
    //           margin: 0,
    //           marginBottom: '1.4rem',
    //           color: '#fff',
    //           fontSize: 'clamp(2.4rem, 5vw, 4.8rem)',
    //           lineHeight: 1,
    //           fontWeight: 950,
    //           letterSpacing: '-2px',
    //         }}
    //       >
    //         {slide.title}
    //       </h2>

    //       <p
    //         style={{
    //           margin: 0,
    //           marginBottom: '2rem',
    //           color: '#cbd5e1',
    //           fontSize: '1.2rem',
    //           lineHeight: 1.75,
    //           maxWidth: '560px',
    //         }}
    //       >
    //         {slide.text}
    //       </p>

    //       <div
    //         style={{
    //           width: '90px',
    //           height: '4px',
    //           borderRadius: '999px',
    //           background: 'linear-gradient(135deg, #38bdf8, #22d3ee)',
    //           marginBottom: '2rem',
    //         }}
    //       />

    //       <div style={{ display: 'flex', alignItems: 'center', gap: '.75rem' }}>
    //         <button onClick={prevSlide} type="button" style={navBtn}>
    //           <ChevronLeft size={22} />
    //         </button>

    //         <button onClick={nextSlide} type="button" style={navBtn}>
    //           <ChevronRight size={22} />
    //         </button>

    //         <div style={{ display: 'flex', gap: '.45rem', marginLeft: '1rem' }}>
    //           {slides.map((_, index) => (
    //             <button
    //               key={index}
    //               type="button"
    //               onClick={() => setCurrent(index)}
    //               style={{
    //                 width: index === current ? '42px' : '10px',
    //                 height: '8px',
    //                 borderRadius: '999px',
    //                 border: 0,
    //                 cursor: 'pointer',
    //                 background:
    //                   index === current
    //                     ? 'linear-gradient(135deg, #38bdf8, #22d3ee)'
    //                     : 'rgba(255,255,255,.35)',
    //                 transition: '.3s ease',
    //               }}
    //             />
    //           ))}
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
    <section
      style={{
        position: 'relative',
        width: '100%',
        height: '700px',
        overflow: 'hidden',
      }}
    >
      <picture>
        {slide.mobileImage && (
          <source media="(max-width: 768px)" srcSet={slide.mobileImage} />
        )}

        <img
          src={slide.image}
          alt={slide.title || ''}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            objectPosition: 'center',
            display: 'block',
            zIndex: 0,
          }}
        />
      </picture>

      {/* Navegação */}
      <div
        style={{
          position: 'absolute',
          bottom: '40px',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '12px',
        }}
      >
        ...
      </div>
    </section>
  );
}

const navBtn = {
  width: '46px',
  height: '46px',
  borderRadius: '14px',
  border: '1px solid rgba(255,255,255,.14)',
  background: 'rgba(255,255,255,.08)',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  backdropFilter: 'blur(12px)',
};